
interface SuccessorType {
  nationalId: string;
  uuid: string;
  fullName: string;
  phone: string;
  email: string;
  address: string;
  postalCode: string;
  city: string;
  isPaid: boolean;
  successorId: number;
}

interface SuccessorDocs {
  id: any;
  uuid: string;
  type: string;
  description: string;
  isAccessibleByReliance: boolean;
  createdAt: string;
  file: SuccessorFile;
}

interface SuccessorFile {
  id: number;
  name: string;
  createdAt: string;
  updatedAt: string;
  url: string;
  uuid: string;
  type: string;
  subDir: string;
}

const successorTypeMap: Record<string, string> = {
  testament: "Testament",
  notarial_documents: "Dokumenty notarialne",
  deed_of_ownership: "Akt własności",
  note: "Notatki prywatne",
};

export type {
  SuccessorType,
  SuccessorDocs,
  SuccessorFile,
};
export {
  successorTypeMap
}

